import Observable from './observable';
export default function filter(predicate, stream) {
    // tslint:disable-next-line:ter-prefer-arrow-callback
    return new Observable(function factory(observer) {
        let index = -1;
        // tslint:disable-next-line:ter-prefer-arrow-callback
        const subscription = stream.subscribe({
            next(value) {
                // tslint:disable-next-line:no-increment-decrement no-param-reassign
                const isAllowed = predicate(value, ++index);
                if (isAllowed) {
                    observer.next(value);
                }
            },
            error(error) {
                observer.error(error);
            },
            complete() {
                observer.complete();
            },
        });
        return function unsubscribe() {
            subscription.unsubscribe();
        };
    });
}
//# sourceMappingURL=filter.js.map